import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosError } from "axios";

interface AvailableTimePayload {
  contactName: string;
  company: string;
  address1: string;
  address2?: string;
  state: string;
  city: string;
  phone: string;
  zipCode: string;
  pickupDate: string;
  closeTime: string;
}

function useSchedulePickupAvailability() {
  const authState = useOktaAuth()?.authState;

  return useMutation({
    mutationKey: ["schedulePickupAvailability"],
    mutationFn: (data: AvailableTimePayload) => {
      return axiosInstance.post(
        "/v1/fedex/schedule-pickup/availability-times",
        data,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
  });
}

export default useSchedulePickupAvailability;
